/* Финздоровье и цвета стадий. ТЗ 7.2, 7.4, 6.3. */
import { isClosedStage } from "./constants.js";

const clamp01 = (t) => Math.max(0, Math.min(1, t));

/** Красный(0) → жёлтый(0.5) → зелёный(1) */
export function healthRGB(t) {
  t = clamp01(t);
  const R = [216, 80, 70], Y = [216, 164, 65], G = [76, 180, 120];
  const mix = (a, b, k) => Math.round(a + (b - a) * k);
  if (t < 0.5) {
    const k = t / 0.5;
    return [mix(R[0], Y[0], k), mix(R[1], Y[1], k), mix(R[2], Y[2], k)];
  }
  const k = (t - 0.5) / 0.5;
  return [mix(Y[0], G[0], k), mix(Y[1], G[1], k), mix(Y[2], G[2], k)];
}

export function health(t) {
  const [r, g, b] = healthRGB(t);
  return {
    t: clamp01(t),
    color: `rgb(${r},${g},${b})`,
    border: `rgba(${r},${g},${b},0.5)`,
    bg: `rgba(${r},${g},${b},0.09)`,
  };
}

/** Зелёная при выручке ≥ 1.5 млн (ТЗ 7.2) */
export const revZone = (v) => health(clamp01((v - 500_000) / 1_000_000));
/** Зелёная при ≥ 3 проектах в работе (ТЗ 7.2) */
export const projZone = (n) => health(Math.min(1, n / 3));

/* ── Цвета этапов: серый → акцент бренда ── */
export const lerpHex = (a, b, t) => {
  const p = (s) => [parseInt(s.slice(1, 3), 16), parseInt(s.slice(3, 5), 16), parseInt(s.slice(5, 7), 16)];
  const A = p(a), B = p(b);
  return "#" + A.map((v, i) => Math.round(v + (B[i] - v) * t).toString(16).padStart(2, "0")).join("");
};

export const stageColor = (i, n) => lerpHex("#b1b1bd", "#4a5ec6", n <= 1 ? 1 : i / (n - 1));

/** Заливка главной карточки: свечение снизу по центру и уход в темноту к краям.
    Раскладку взяли с исходной тёмно-синей карточки, чтобы любой цвет бизнеса
    выглядел так же — светлое пятно, база, три ступени затемнения. */
export const heroGradient = (hex) => {
  const dark = (t) => lerpHex(hex, "#0b0d24", t);
  return "radial-gradient(115% 85% at 50% 120%, "
    + `${lerpHex(hex, "#ffffff", 0.42)} 0%, ${hex} 28%, `
    + `${dark(0.42)} 55%, ${dark(0.68)} 78%, ${dark(0.86)} 100%)`;
};

export function accStageColor(stage, stages) {
  if (isClosedStage(stage)) return "#c4c2cc";
  const active = stages.filter((s) => !isClosedStage(s));
  const idx = active.indexOf(stage);
  return stageColor(idx < 0 ? 0 : idx, active.length);
}

/* Здоровья воронки и весов этапов здесь больше нет: одна цифра, взвешенная
   деньгами по номеру этапа, отвечала не на тот вопрос — закрытые сделки тянули
   её вверх, лиды без суммы не считались вовсе. Воронку смотрят по сделкам. */

export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
